var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    transform: "rotate(-180 19 19)",
    fill: "white",
    stroke: "#505D6F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1991 25.4037L15.2704 19.4926C15.2 19.4222 15.15 19.346 15.1205 19.2639C15.0909 19.1818 15.0764 19.0938 15.0769 19C15.0769 18.9062 15.0914 18.8182 15.1205 18.7361C15.1496 18.654 15.1995 18.5778 15.2704 18.5074L21.1991 12.5787C21.3633 12.4145 21.5685 12.3324 21.8148 12.3324C22.0611 12.3324 22.2722 12.4204 22.4481 12.5963C22.6241 12.7722 22.712 12.9775 22.712 13.212C22.712 13.4466 22.6241 13.6518 22.4481 13.8278L17.2759 19L22.4481 24.1722C22.6123 24.3364 22.6944 24.5388 22.6944 24.7795C22.6944 25.0202 22.6065 25.2282 22.4306 25.4037C22.2546 25.5796 22.0494 25.6676 21.8148 25.6676C21.5802 25.6676 21.375 25.5796 21.1991 25.4037Z",
    fill: "#505D6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.ccd208b7075c314bd769d66465d03981.svg";
export { ForwardRef as ReactComponent };